import React from 'react';

import { cn } from '@blockworks/ui/utils';

type ITwitterProps = {
    className?: string;
    style?: 'primary' | 'black';
    width?: number;
    height?: number;
};

const TwitterIcon = (props: ITwitterProps) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props.width}
            height={props.height}
            viewBox="0 0 14 11"
            fill="none"
            className={cn('relative', props.style === 'primary' ? 'text-primary-dark' : 'text-black', props.className)}
        >
            <path
                d="M13.6654 1.41626C13.1654 1.66626 12.6654 1.74959 12.082 1.83293C12.6654 1.49959 13.082 0.999593 13.2487 0.332926C12.7487 0.66626 12.1654 0.832926 11.4987 0.999593C10.9987 0.499593 10.2487 0.16626 9.4987 0.16626C8.08203 0.16626 6.83203 1.41626 6.83203 2.91626C6.83203 3.16626 6.83203 3.33293 6.91536 3.49959C4.66536 3.41626 2.58203 2.33293 1.2487 0.66626C0.998698 1.08293 0.915364 1.49959 0.915364 2.08293C0.915364 2.99959 1.41536 3.83293 2.16536 4.33293C1.7487 4.33293 1.33203 4.16626 0.915364 3.99959C0.915364 5.33293 1.83203 6.41626 3.08203 6.66626C2.83203 6.74959 2.58203 6.74959 2.33203 6.74959C2.16536 6.74959 1.9987 6.74959 1.83203 6.66626C2.16536 7.74959 3.16536 8.58293 4.41536 8.58293C3.4987 9.33293 2.33203 9.74959 0.998698 9.74959C0.748698 9.74959 0.582031 9.74959 0.332031 9.74959C1.58203 10.4996 2.9987 10.9996 4.4987 10.9996C9.4987 10.9996 12.2487 6.83293 12.2487 3.24959C12.2487 3.16626 12.2487 2.99959 12.2487 2.91626C12.832 2.49959 13.332 1.99959 13.6654 1.41626Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default TwitterIcon;
